module.exports = __webpack_public_path__ + "static/media/icon-adherence-issue-happy.e451a37f.svg";